import styled, { keyframes } from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import { useState } from "react";
import axios from "axios";

import { LuLoaderCircle } from "react-icons/lu";

const spin = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;
const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 5px;
`
const Title = styled.h2`
    margin: 0;
    color: #000;
`
const SideTitle = styled.h3`
    margin: 5px 0 0 0;
    color: #0000006a;
`
const ContainerBotoes = styled.div`
    width: 100%;
    height: 40px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
`
const Botao = styled.button`
    width: calc( 50% - 5px );
    height: 100%;
    border: none;
    border-radius: 8px;
    box-sizing: border-box;
    &.cancel{
        background: #fff;
        border: 2.5px solid #ccc;
        color: #ccc;
        font-weight: bold;
    }
    &.delete {
        background: #d64343;
        color: white;
        font-weight: bold;
    }
    cursor: pointer;
    transition: .3s;
    &:hover{
        scale: 1.04;
    }
`
const ContainerSaving = styled.div`
    width: 25px;
    height: 25px;
    margin: auto;
`
const IconSaving = styled(LuLoaderCircle)`
    width: 100%;
    height: 100%;
    color: white;
    animation: ${spin} 1s linear infinite;
`

const ModalDeleteMeta = ({ item, fecharModal, atualizarUsers, atualizarMetas }) => {

    const [saving, setSaving] = useState(false);

    const submitDelete = async () => {
        setSaving(true);

        try {
            const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/Checklist/DeleteMeta/', {
                id: item.id
            })

            console.log(data);
            await atualizarUsers();
            await atualizarMetas();

            fecharModal();
        } catch (e) {
            console.log(e);
        } finally {
            setSaving(false);
        }
    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="sm" >
                    <Container>
                        <Title>Excluir Meta Semanal</Title>
                        <SideTitle>Tem certeza que deseja excluir a meta {item.nome} ?</SideTitle>
                        <ContainerBotoes>
                            <Botao className="cancel" onClick={fecharModal} disabled={saving} >Cancelar</Botao>
                            <Botao className="delete" onClick={submitDelete} disabled={saving} >
                                {saving ? 
                                    <ContainerSaving>
                                        <IconSaving />
                                    </ContainerSaving>
                                : "Excluir"}
                            </Botao>
                        </ContainerBotoes>
                    </Container>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalDeleteMeta;